export default{
  setGTagData(state , payload){
    state.gTagData = payload
  }
}